export type IntegrationOauthProvider = 'google_drive' | 'slack' | 'jira';
export type IntegrationOauthScope = 'user' | 'organisation';
export type IntegrationOauthOrigin = 'integrations_org' | 'profile_user';

export interface IntegrationOauthContext {
  provider: IntegrationOauthProvider;
  origin: IntegrationOauthOrigin;
  scope: IntegrationOauthScope;
  /**
   * The CSRF `state` handed to the provider, to be compared against the value echoed back on the
   * callback. Optional: the Google Drive and Slack flows do not verify it, only Jira does.
   */
  state?: string;
}

export const INTEGRATION_OAUTH_SCOPE_KEY = 'integration_oauth_scope';
export const INTEGRATION_OAUTH_CONTEXT_KEY = 'integration_oauth_context';

export function setIntegrationOauthContext(context: IntegrationOauthContext): void {
  window.sessionStorage.setItem(INTEGRATION_OAUTH_SCOPE_KEY, context.scope);
  window.sessionStorage.setItem(INTEGRATION_OAUTH_CONTEXT_KEY, JSON.stringify(context));
}

export function readIntegrationOauthContext(): IntegrationOauthContext | null {
  const raw = window.sessionStorage.getItem(INTEGRATION_OAUTH_CONTEXT_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as Partial<IntegrationOauthContext> | null;
    if (!parsed?.provider || !parsed.origin || !parsed.scope) {
      return null;
    }
    return {
      provider: parsed.provider,
      origin: parsed.origin,
      scope: parsed.scope,
      ...(parsed.state ? { state: parsed.state } : {}),
    };
  } catch {
    return null;
  }
}

export function clearIntegrationOauthContext(): void {
  window.sessionStorage.removeItem(INTEGRATION_OAUTH_SCOPE_KEY);
  window.sessionStorage.removeItem(INTEGRATION_OAUTH_CONTEXT_KEY);
}
